import Linker from './LinkerActions'


/** 
 * Описание элементов для установки связи элементов
 */

const initialLinkerState = {
	//Вид представление. Может содержать массив доступных видов
	//null или [] - отображаются все вкладки
  view: null,
  //Состояние отображения
  state: null,
  //Субъект для связи
  s: null,
  //Предикат для связи
  p: null,
  //Объект для связи
  o: null,
  //Метка описание связи
  label: undefined,
}

export const linker = (state = { ...initialLinkerState} , action) => {
  switch (action.type) {
    case Linker.EMPTY: 
      return{
        ... initialLinkerState
      }
    case Linker.SHOW: 
      return{
        ...state,
        state: "show",
				view: action.view,
				s: action.s,
      }
		case Linker.LINK: 
      return{
        ...state,
        state: "link",
				p: action.p,
				o: action.o,
      }
		case Linker.SELECTED: 
      return{
        ...state,
				p: action.p,
        o: action.o,
        label: action.label,
      }
    default:
      return state;
  }
}

